import React, { useCallback, useMemo } from 'react';
import { Checkbox } from '@mui/material';
import { TimeSignal } from 'graphql/types';
import { useNotesItemHeaderCheckActions } from './hooks/useNotesItemHeaderCheckActions';

type NoteListGroupHeaderCheckboxProps = {
  groupKey: string;
  notes: TimeSignal[];
  totalCount: number;
};

export const NotesListGroupHeaderCheckbox: React.FC<NoteListGroupHeaderCheckboxProps> = ({
  groupKey,
  notes,
  totalCount
}: NoteListGroupHeaderCheckboxProps) => {
  const { indeterminate, selectAll, onChange } = useNotesItemHeaderCheckActions(
    {
      notes,
      watchId: groupKey,
      totalCount
    }
  );

  const inputProps = useMemo(
    () => ({
      inputProps: {
        'data-testid': `notes-list-group-header-clickable-checkbox_${groupKey}`
      } as any
    }),
    [groupKey]
  );
  const stopPropogationClick = useCallback(
    (event: any) => event.stopPropagation(),
    []
  );

  return (
    <Checkbox
      data-testid={`notes-list-group-header-select-checkbox_${groupKey}`}
      color="default"
      checked={selectAll}
      indeterminate={indeterminate}
      onChange={onChange}
      onClick={stopPropogationClick}
      {...inputProps}
    />
  );
};
